import { switchBreakpoint } from 'SiteLayout/CurrentBreakpoint/action-creators';
import { on } from 'SiteLayout/Root';
// If changing these constants, change the Breakpoint enum in Avensia.React/Device/Breakpoints.cs the same way
export const INIT = 0;
export const MICRO = 1;
export const TINY = 2;
export const SMALL = 3;
export const MEDIUM = 4;
export const LARGE = 5;
export const HUGE = 6;
const MENIGO_LAYOUT_BREAKPOINTS = {
    init: 0,
    micro: 320,
    tiny: 480,
    small: 768,
    medium: 992,
    large: 1200,
    huge: 1560
};
// If the breakpoint is MICRO (which is set to 320) the width is at minium 320
// so you get the width for the next breakpoint (TINY) because the screen could be up til
// TINY
export function widthFromBreakpoint(breakpoint) {
    const keys = Object.keys(MENIGO_LAYOUT_BREAKPOINTS);
    if (typeof breakpoint !== 'number' || breakpoint < 0 || breakpoint > keys.length - 1) {
        throw new Error('Invalid breakpoint: ' + breakpoint);
    }
    const name = keys[breakpoint + 1];
    return name ? MENIGO_LAYOUT_BREAKPOINTS[name] : MENIGO_LAYOUT_BREAKPOINTS[keys[keys.length - 1]];
}
export function breakpointFromWidth(width) {
    const breakpoints = MENIGO_LAYOUT_BREAKPOINTS; // eslint-disable-line no-undef
    const keys = Object.keys(breakpoints);
    for (let i = 0; i < keys.length; i++) {
        const curr = breakpoints[keys[i]];
        const next = breakpoints[keys[i + 1]] || Infinity;
        if (curr <= width && next > width) {
            return i;
        }
    }
    if (process.env.NODE_ENV !== 'production') {
        console.error('Could not match a breakpoint. window.innerWidth:', window.innerWidth, 'keys:', keys, 'breakpoints:', breakpoints);
    }
    else {
        return keys.length - 1;
    }
}
export function current() {
    let currentWidth = window.innerWidth;
    return breakpointFromWidth(currentWidth);
}
export function setupResizeListener(store) {
    let currentBreakpoint = current();
    // We use `Root/on` here to enable the throttled variant of `window.addEventListener('resize', ...`
    on('resize', () => {
        const newBreakpoint = current();
        if (currentBreakpoint !== newBreakpoint) {
            currentBreakpoint = newBreakpoint;
            store.dispatch(switchBreakpoint(currentBreakpoint));
        }
    });
}
